import LogRocket from 'logrocket';

import type { ObservabilitySeverity, ObservabilitySink, ObservabilityUser } from '../types';

/**
 * LogRocket observability sink for error/message capture and user identity.
 * LogRocket is initialized (with its network sanitizers) by each app's
 * AnalyticsServices; the SDK no-ops safely if called before init.
 */
export function createLogRocketSink(): ObservabilitySink {
  return {
    name: 'LOGROCKET',

    identifyUser(user: ObservabilityUser) {
      if (user.kind === 'CANDIDATE') {
        if (!user.email || !user.orgId) {
          return;
        }
        LogRocket.identify(user.orgId, {
          email: user.email,
          org_id: user.orgId,
          org_name: user.orgName ?? '',
        });
        return;
      }

      if (!user.employeeId || !user.orgId) {
        return;
      }
      LogRocket.identify(user.employeeId, {
        email: user.userEmail ?? '',
        name: user.userName ?? '',
        organizationId: user.orgId,
        organizationName: user.orgName ?? '',
      });
    },

    reportError(cause: unknown) {
      if (cause instanceof Error) {
        LogRocket.captureException(cause);
      } else {
        LogRocket.captureMessage(String(cause));
      }
    },

    reportMessage(message: string, level: ObservabilitySeverity) {
      LogRocket.captureMessage(message, {
        tags: {
          severity: level.toString(),
        },
      });
    },
  };
}
